import { useTranslation } from 'react-i18next';
import { Modal, ScrollArea } from '@mantine/core';
import React from 'react';


type Props = {
    children: React.ReactNode,
    onClose?: () => void,
    opened?: boolean
    header?: React.ReactNode
    footer?: React.ReactNode
    size?: string
    withCloseButton?: boolean
    closeOnEscape?: boolean
    padding?: string
}

export default function CardModal({
    children,
    onClose,
    opened,
    header,
    footer,
    size,
    withCloseButton = true,
    closeOnEscape = true,
    padding,
}: Props) {
    return (
        <Modal
            trapFocus
            withCloseButton={withCloseButton}
            opened={opened}
            onClose={onClose}
            title={header}
            size={size || "100%"}
            padding="0"
            radius="lg"
            closeOnEscape={closeOnEscape}
            closeOnClickOutside={closeOnEscape}
            styles={{
                content: {
                    border: '1px solid rgba(55, 53, 47, 0.09)',
                    boxShadow: 'rgba(15, 15, 15, 0.05) 0px 0px 0px 1px, rgba(15, 15, 15, 0.1) 0px 5px 10px, rgba(15, 15, 15, 0.2) 0px 15px 40px',
                },
                header: {
                    padding: '10px 20px',
                    borderBottom: '1px solid rgba(55, 53, 47, 0.09)',
                    minHeight: 'auto',
                },
                title: {
                    width: '100%',
                    flex: 1,
                }
            }}
        >
            <div
                style={{
                    padding: padding || '18px 20px',
                }}
            >
                {children}
            </div>
            {footer && (
                <div
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: 'white',
                        borderTop: '1px solid rgba(55, 53, 47, 0.09)',
                        padding: '10px 20px',
                        borderRadius: '0 0 12px 12px',
                        zIndex: 10
                    }}
                >
                    {footer}
                </div>
            )}
        </Modal >
    );
}